import { useMutation } from '@tanstack/react-query'
import client from 'src/client'

export function useReadNotifications() {
  return useMutation({
    async mutationFn({ userId, notifIds }: { userId: string; notifIds: string[] }) {
      return client.api.post(`/notifications/${userId}`, notifIds)
    }
  })
}

export function useReadAllNotification() {
  return useMutation({
    async mutationFn({ userId }: { userId: string }) {
      return client.api.post(`/notifications/${userId}`)
    }
  })
}
